import React from 'react';
import editImg from '../../../asset/images/IBA/editImg.svg';

const AgentPersonalDetails = ({ type, data, onEditClick }) => {
  return (
    <div className="performance-box-wrapper personal">
      <div className="top-title">
        <div className="left-title">
          {type === "personal" ? "Personal Details" : "Bank Details"}
        </div>
        <img src={editImg} alt='editImg' onClick={() => onEditClick(type, data)}/>
      </div>
      <div className="personal-data">
        <div className="right-personal-data">
          {type === "personal" ? (
            <>
              <div className="personal-details">
                <span className='details-text'>Full Name :</span>
                <span className='details-value'>{data.fullName}</span>
              </div>
              <div className="personal-details">
                <span className='details-text'>DOB :</span>
                <span className='details-value dob'>{data.dob}</span>
              </div>
              <div className="personal-details">
                <span className='details-text'>Gender :</span>
                <span className='details-value'>{data.gender}</span>
              </div>
              <div className="personal-details">
                <span className='details-text'>Address :</span>
                <span className='details-value'>{data.address}</span>
              </div>
              <div className="personal-details">
                <span className='details-text'>Aadhaar :</span>
                <span className='details-value'>{data.aadhaar}</span>
              </div>
              <div className="personal-details">
                <span className='details-text'>PAN :</span>
                <span className='details-value'>{data.pan}</span>
              </div>
            </>
          ) : (
            <>
              <div className="personal-details">
                <span className='details-text'>Account Number :</span>
                <span className='details-value'>{data.accountNumber}</span>
              </div>
              <div className="personal-details">
                <span className='details-text'>IFSC Code :</span>
                <span className='details-value'>{data.ifscCode}</span>
              </div>
              <div className="personal-details">
                <span className='details-text'>MICR :</span>
                <span className='details-value'>{data.micr}</span>
              </div>
              <div className="personal-details">
                <span className='details-text'>Branch Name :</span>
                <span className='details-value'>{data.branchName}</span>
              </div>
              <div className="personal-details">
                <span className='details-text'>Branch Address :</span>
                <span className='details-value'>{data.branchAddress}</span>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AgentPersonalDetails;
